import { createFeatureSelector, createSelector } from '@ngrx/store';
import { updateProductPriceFeatureKey, UpdateProductPriceState, UPDATE_PRODUCT_PRICE } from './uig-product-price-calculator.reducer';

export const selectUpdateProductPriceState = createFeatureSelector<UpdateProductPriceState>(
    updateProductPriceFeatureKey
  );
    
export const selectUpdateProductPrice = createSelector(
    selectUpdateProductPriceState,
    (state: UpdateProductPriceState) =>
        state[UPDATE_PRODUCT_PRICE].updateProductPrice
);

export const loadingUpdateProductPrice = createSelector(
    selectUpdateProductPriceState,
    (state: UpdateProductPriceState) =>
        state[UPDATE_PRODUCT_PRICE].isLoading
);

export const errorUpdateProductPrice = createSelector(
    selectUpdateProductPriceState,
    (state: UpdateProductPriceState) =>
        state[UPDATE_PRODUCT_PRICE].error
);